module.exports = __webpack_public_path__ + "img/SS.d6c4a6c3.png";